var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.03,
    height: 17.034,
    viewBox: "0 0 17.03 17.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search-2",
    "data-name": "Icon ionic-ios-search",
    d: "M21.33,20.294l-4.736-4.781a6.75,6.75,0,1,0-1.024,1.038l4.705,4.75a.729.729,0,0,0,1.029.027A.734.734,0,0,0,21.33,20.294ZM11.29,16.609a5.33,5.33,0,1,1,3.77-1.561A5.3,5.3,0,0,1,11.29,16.609Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.85fd9bc8daf947a211296c33df9805d2.svg";
export { ForwardRef as ReactComponent };